var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.noticeShow,
          expression: "noticeShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "transferNotice" } }, [
        _c("div", { staticClass: "title" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.popup.cancel")))]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                _vm.noticeShow = false
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "notice-all-content" }, [
          _c("span", [
            _vm._v(_vm._s(_vm.$t("language.cloudTransfer.sureContinue")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "notice-all-footer" }, [
          _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "40Px",
                "vertical-align": "middle"
              }
            },
            [
              _c(
                "button",
                {
                  ref: "b1",
                  staticStyle: {
                    "margin-right": "50Px",
                    "border-radius": "5Px",
                    "min-width": "107Px"
                  },
                  on: {
                    click: function($event) {
                      return _vm.transferData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.cloudTransfer.sure")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  ref: "b2",
                  staticClass: "cancel-button-two",
                  on: {
                    click: function($event) {
                      return _vm.closeNotice()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02dbc218", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02dbc218","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_transfer_popups/transfer_notice_popup.vue
// module id = null
// module chunks = 